module.exports = __webpack_public_path__ + "img/florasprings.c47c8b72.jpeg";